// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"345e2b75","114":"d0cd40ad","464":"3cd7b562","631":"9fc21e43","882":"4a1485e9"}[chunkId] + ".chunk.js";
};